import React, { useState, useEffect, useMemo, } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Grid, useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import {
    DialogSystemGLPure,
    SimpleLoading,
    SubtitlePageHLPure,
    InputHLPure,
    Traslates,
    DataPickerHLPure,
    TextAreaHLPure,
    GridSelectionHLPure,
    ButtonHLPure,
    PromotionalFooterPure,
    DialogPdfHLPure,
    Label,
    DialogPdf,
    PanelBarGLPure,
    DialogYesNoHLPure
} from '../../pures';
import PdfViewerAction from '../../actions/pdf-viewer/pdf-viewer.action'
import { b64toBlob } from "./../../../validators";
import "./contract-repse.view.css";

const ContractRepseView = (props) => {
    const { t } = useTranslation();
    let history = useHistory();

    let {
        isNewContract,
        loadingView,
        showCompletedRequesting,
        showErrorRequesting,
        showLoadingRequesting,
        messageError,
        toggleCompletedRequesting,
        toggleErrorRequesting,
        toggleLoadingRequesting,
        titleView,
        documents,
        handleCreateUpdateContract,
        contract,
        company,
        proveedorName,
        handleFile,
        handleDeleteFile,
        handleUploadDocument,
        proveedorRepse,
        deleteRepseContract,
        onContractorSelected,
        toggleContractDetailsScreen,
        selectedContractor
    } = props

    let today = new Date()
    let finishDateDeafult = new Date();
    finishDateDeafult.setDate(finishDateDeafult.getDate() + 61);


    const headerColumnOneItem1 = (props) => {
        return <span className="contractRepseView-header-cell-one">{props.title}</span>;
    };

    const cellColumnOne = (props) => {
        return (
            <td className='contractRepseView-cell-one'>
                <div className={"gridHLPure-containerLabel"}>
                    <span className="gridHLPure-userName">
                        {props.dataItem.name}
                    </span>
                    <div className="gridHLPure-detailsContainer">
                        <span className="gridHLPure-fieldSubtitle">
                            {props.dataItem.uploaded}
                        </span>
                    </div>
                </div>
            </td>
        );
    };

    const [contractName, setContractName] = useState('')
    const [reference, setReference] = useState('')
    const [startDate, setStartDate] = useState()
    const [finishDate, setFinishDate] = useState()
    const [maxSecondDate, setMaxSecondDate] = useState(finishDateDeafult)
    const [errorInDate, setErrorInDate] = useState(false)
    const [reason, setReason] = useState('')
    const [documentsGrid, setDataGridDocumentsGrid] = useState(documents)
    const [documentSelected, setDocumentSelected] = useState({})
    const [urlPdfContract, setUrlPdfContract] = useState("");
    const [showModalPdf, setShowModalPdf] = useState(false)
    const [showAWS, setShowAws] = useState(true)
    const [urlPdf, setUrlPdf] = useState('')
    const [selectedFileBase64, setSelectedFileBase64] = useState('')
    const [blobUrl, setBlobUrl] = useState("");
    const [showPdfContarct, setShowPdfContarct] = useState(true)
    const [showDialogDelete, setShowDialogDelete] = useState(false)

    const pdfContract = useMemo(() => (<PdfViewerAction url={urlPdfContract} isExtended={false} isSSRActive={false} />), [urlPdfContract]);
    const pdfAws = useMemo(() => <PdfViewerAction url={urlPdf} isExtended={false} isSSRActive={false} />, [urlPdf])
    const pdf = useMemo(() => {
        const pdfUrl = selectedFileBase64 ? `data:application/pdf;base64,${selectedFileBase64}` : '';
        return <PdfViewerAction url={pdfUrl} isExtended={false} isSSRActive={false} />
    }, [selectedFileBase64])

    const mobileResolution = useMediaQuery("(max-width:560px)");
    let heightContainer = mobileResolution ? 450 : 800
    let widthContainer = mobileResolution ? 550 : 1000
    let heightBody = mobileResolution ? 230 : 520

    useEffect(() => {
        if (isNewContract === false && contract && contract.id) {
            let firstDate = (contract.startDate && contract.startDate !== '') ? new Date(contract.startDate) : ''
            let secondtDate = (contract.endDate && contract.endDate !== '') ? new Date(contract.endDate) : ''
            setContractName(contract.name)
            setReference(contract.reference)
            setStartDate(firstDate)
            setFinishDate(secondtDate)
            setReason(contract.contractReason)
        }

    }, [isNewContract, contract])

    useEffect(() => {
        if (props.selectedFileBase64) {
            const blob = b64toBlob(props.selectedFileBase64, "application/pdf");
            setBlobUrl(blob);
            setSelectedFileBase64(props.selectedFileBase64)
        }
    }, [props.selectedFileBase64]);

    useEffect(() => {
        if (!documents || documents.length === 0) return
        setDataGridDocumentsGrid(documents)
        setUrlPdfContract(documents[0].path)
        toggleLoadingRequesting(false)
    }, [documents])

    const onChangeContractName = (e) => {
        let value = e.target.value
        setContractName(value)
    }

    const handleChangeStartDate = (e) => {
        let value = e.target.value
        if (value === null) {
            setErrorInDate(true)
            return
        }

        if (value > finishDate) {
            setFinishDate(value)
        }
        setStartDate(value)
    }

    const onHandleFinishDate = (e) => {
        let value = new Date(e.target.value);
        if (value === null) {
            setErrorInDate(true)
            return
        }
        setFinishDate(value);
    }

    const onChangeReason = (e) => {
        let value = e.target.value
        setReason(value)
    }

    const onClickUploadGrid = (documento) => {
        setShowPdfContarct(false)
        setShowAws(true)
        setShowModalPdf(true)
        setUrlPdf(documento.path)
        setDocumentSelected(documento)
    }

    const onChangeReference = (e) => {
        let value = e.target.value
        setReference(value)
    }

    const handleBack = () => {
        toggleContractDetailsScreen(true)
        onContractorSelected(selectedContractor)
        toggleContractDetailsScreen(false)
    }

    const handleSubmit = () => {
        toggleLoadingRequesting(true)
        let errorMessage = 'Ocurrió un error al guardar la información del documento'
        if (!contractName || contractName === '' || !reference || reference === '') {
            errorMessage = (!contractName || contractName === '') ? 'Agrega un nombre al contrato' : "Agrega una referencia al contrato"
            toggleLoadingRequesting(false)
            toggleErrorRequesting(errorMessage, 4000, false)
            return
        }

        if (!startDate || startDate === '') {
            errorMessage = "Selecciona una fecha de inicio del contrato"
            toggleLoadingRequesting(false)
            toggleErrorRequesting(errorMessage, 4000, false)
            return
        }

        let allDocsLoaded = documents.find((doc) => doc.docWasLoaded === false && doc.clientDocumentTypeRequest.id === 2)
        if (allDocsLoaded) {
            errorMessage = "Cargar todos los documentos obligatorios *"
            toggleLoadingRequesting(false)
            toggleErrorRequesting(errorMessage, 4000, false)
            return
        }

        let paths = []
        documents.map((doc) => {
            if (doc.clientDocumentTypeRequest.id === 2 && doc.docWasLoaded === true) {
                paths.push(doc.pathToSearch)
            }

            return doc
        })

        let contractInfo = {}
        contractInfo.name = contractName
        contractInfo.reference = reference
        contractInfo.startDate = startDate
        contractInfo.endDate = finishDate
        contractInfo.contractReason = reason
        contractInfo.companyId = company.id
        contractInfo.contractorId = proveedorRepse.id
        contractInfo.vaultId = 10
        contractInfo.id = (isNewContract === false) ? contract.id : null
        contractInfo.paths = paths
        handleCreateUpdateContract(contractInfo)
    }

    const handleCloseModalPDF = () => {
        setShowPdfContarct(true)
        handleDeleteFile()
        setShowModalPdf(false)
    }

    const onChangeUploadFile = (e) => {
        if (!e) {
            let errorMessage = 'Selecciona un documento'
            toggleErrorRequesting(errorMessage, 4000, false)
        }
        toggleLoadingRequesting(true)
        let file = e.target.files[0]
        let documentContract = new FormData();
        let documentId = documentSelected.documentId
        let companyId = company.id
        documentContract.append("documentContract", file);
        documentContract.append("documentId", documentId);
        documentContract.append("statusId", 2);
        documentContract.append("companyId", companyId);
        if (!isNewContract && contract) {
            documentContract.append("repseContractId", contract.id);
        }

        if (documentSelected.repseContDocId) {
            documentContract.append("id", documentSelected.repseContDocId)
        }
        handleUploadDocument(e, documentContract, setShowAws, setUrlPdf)
    }

    const handleModalDelete = () => {
        setShowDialogDelete(true)
    }

    const closeShowDialogDelete = () => {
        setShowDialogDelete(false)
    }

    const handleDeleteContract = () => {
        deleteRepseContract(contract.id)
    }

    return (
        <div className='contractRepseView-wrapper'>
            {
                loadingView ? (
                    <SimpleLoading />
                ) : (
                    <Container
                        xs={12}
                        lg={12}
                        md={12}
                        sm={12}
                        spacing={4}
                        className="contractRepseView-container"
                    >
                        <Grid
                            item
                            lg={12}
                            md={12}
                            xs={12}
                            sm={12}
                            className='contractRepseView-navbar'
                        >
                            <SubtitlePageHLPure
                                subtitle={titleView}
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            className='contractRepseView-body'
                        >
                            <div className='contractRepseView-data-pdf-container'>
                                <div>
                                    <PanelBarGLPure
                                        expandedPanel={true}
                                        titlePanel={t("contractRepseView.title.panel.contract")}
                                    >
                                        <div className='contractRepseView-data-container'>
                                            <InputHLPure
                                                labelInput={t("contractRepseView.company")}
                                                typeInput={"text"}
                                                valueInput={company.name}
                                                inputActive={true}
                                                disabled={true}
                                            />
                                            <InputHLPure
                                                labelInput={t("contractRepseView.proveedor")}
                                                typeInput={"text"}
                                                valueInput={proveedorRepse.name}
                                                inputActive={true}
                                                disabled={true}
                                            />
                                            <InputHLPure
                                                labelInput={t("contractRepseView.name.contract")}
                                                typeInput={"text"}
                                                valueInput={contractName}
                                                handleChangeInput={(e) => onChangeContractName(e)}
                                                inputActive={true}
                                            />
                                            <InputHLPure
                                                labelInput={t("contractRepseView.reference")}
                                                typeInput={"text"}
                                                valueInput={reference}
                                                handleChangeInput={(e) => onChangeReference(e)}
                                                inputActive={true}
                                            />
                                            <div className='contractRepseView-dates'>
                                                <Traslates>
                                                    <DataPickerHLPure
                                                        labelDataPicker={t("contractRepseView.date.start")}
                                                        valueDate={startDate}
                                                        handleChangeDate={(e) => handleChangeStartDate(e)}
                                                    />
                                                </Traslates>
                                                <Traslates>
                                                    <DataPickerHLPure
                                                        labelDataPicker={t("contractRepseView.date.end")}
                                                        valueDate={finishDate}
                                                        limitDate={startDate}
                                                        handleChangeDate={(e) => onHandleFinishDate(e)}
                                                    />
                                                    {errorInDate ? (
                                                        <span className="hint-message-error">
                                                            Ingrese una fecha correcta
                                                        </span>
                                                    ) : null
                                                    }
                                                </Traslates>
                                            </div>
                                            <TextAreaHLPure
                                                labelTextArea={t("contractRepseView.descripcion")}
                                                valueTextData={reason}
                                                handleChangeTextArea={(e) => onChangeReason(e)}
                                            />
                                        </div>
                                    </PanelBarGLPure>
                                    <div className='contractRepseView-panel-2'>
                                        <PanelBarGLPure
                                            expandedPanel={false}
                                            titlePanel={t("contractRepseView.title.panel.documents")}
                                            className='contractRepseView-panel-2'
                                        >
                                            <Grid item className={(documents.length > 7) ? "contractRepseView-grid-documents-scroll" : "contractRepseView-grid-documents"}>
                                                <GridSelectionHLPure
                                                    styleGeneral={true}
                                                    styleGeneralClass={"contractRepseView-general-grid"}
                                                    pageable={false}
                                                    skip={0}
                                                    take={documentsGrid.length}
                                                    dataGrid={documentsGrid}
                                                    filter={true}
                                                    onSelectedItem={setDocumentSelected}
                                                    setNameComponentUser={() => console.log('')}
                                                    setShowDetails={() => console.log('')}
                                                    headerColumnOne={headerColumnOneItem1}
                                                    cellColumnOne={cellColumnOne}
                                                    columnFive={true}
                                                    titleRow1={t("contractRepseView.column.1")}
                                                    titleRow5={t("contractRepseView.column.2")}
                                                    iconOneActive={true}
                                                    labelOneActions={t("contractRepseView.updload.document")}
                                                    activeDialog1={true}
                                                    btnOpenDialog1={(dataItem) => onClickUploadGrid(dataItem)}
                                                    styleGrid={{ maxHeight: '400px' }}
                                                    mobileFunction={true}
                                                />
                                            </Grid>
                                        </PanelBarGLPure>
                                    </div>
                                </div>
                                <div className='contractRepseView-pdf-container'>
                                    {showPdfContarct ? (
                                        <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className="contractRepseView-pdf"
                                        >
                                            {pdfContract}
                                        </Grid>
                                    ) : null
                                    }
                                </div>
                            </div>
                            <div className='contractRepseView-btns-container'>
                                <div className='contractRepseView-btn-back'>
                                    <ButtonHLPure
                                        primary={false}
                                        nameBtn={t("button.return")}
                                        onClickBtn={handleBack}
                                    />
                                </div>
                                {/* {
                                    !isNewContract ? (
                                        <div className='contractRepseView-btn-back'>
                                            <ButtonHLPure
                                                primary={false}
                                                nameBtn={t("button.delete")}
                                                onClickBtn={handleModalDelete}
                                            />  
                                        </div>
                                    ) : null
                                }   */}
                                <ButtonHLPure
                                    primary={true}
                                    nameBtn={t("contractRepseView.btn.save")}
                                    onClickBtn={handleSubmit}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} lg={12} md={12} sm={12}>
                            <PromotionalFooterPure />
                        </Grid>
                        {
                            showModalPdf && (
                                <DialogPdfHLPure
                                    title={t("contractRepseView.title.modal.upload")}
                                    description={(documentSelected && documentSelected.name) ? documentSelected.name : 'Selecciona un documento'}
                                    canelBtn={t("dialogResendSignatureRequest.buttonClose")}
                                    width={widthContainer}
                                    height={heightContainer}
                                    heightBody={heightBody}
                                    handleFile={handleFile}
                                    cancel={handleCloseModalPDF}
                                >
                                    <div className="contractingRegistrationDocumentsView-card">
                                        <Grid container lg={12} md={12} sm={12} es={12}>
                                            <Grid
                                                item
                                                lg={12}
                                                md={12}
                                                sm={12}
                                                es={12}
                                                className="container-btns-pdf"
                                            >
                                                {/* Input File */}
                                                <Grid item xs={6} lg={6} md={6} sm={6} es={6}>
                                                    <div className="contractingRegistrationDocumentsView-container-upload-document">
                                                        <Label className="form-label-upload">
                                                            {t("contractRepseView.title.modal.upload")}
                                                        </Label>
                                                        <div className="style-document-upload">
                                                            <div className="custom-input-upload-file">
                                                                <i className="k-icon k-i-plus SignatureRequestProfileDocumentView-icon-plus"
                                                                    style={{
                                                                        fontSize: "20px",
                                                                        marginLeft: "-5px",
                                                                        marginTop: "-8px",
                                                                        marginRight: "10px",
                                                                    }}
                                                                ></i>
                                                                <input
                                                                    className="input-upload-file"
                                                                    type="file"
                                                                    accept="application/pdf"
                                                                    id="file-picker"
                                                                    onClick={(e) => (e.target.value = null)}
                                                                    onChange={(e) => {
                                                                        onChangeUploadFile(e);
                                                                    }}
                                                                />
                                                                {t("signatureRequestView2.pdf")}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={6} lg={6} md={6} sm={6} es={6}>
                                                    <div className="container-name-document">
                                                        <div
                                                            className={`input-upload-file-leyend ${props.colorBorderContainer}`}
                                                        >
                                                            <p className="input-file-leyend-name">
                                                                {!props.selectedFile
                                                                    ? `${t("signatureRequestView2.notuploadDocument")}`
                                                                    : `${props.selectedFileName}`
                                                                }
                                                            </p>
                                                        </div>
                                                        <span className="input-file-leyend-icon">
                                                            {props.selectedFile && (
                                                                <i className="k-icon k-i-check-circle k-i-checkmark-circle"></i>
                                                            )}
                                                        </span>
                                                    </div>
                                                    {props.errorFile && (
                                                        <span className="hint-message-error-document">
                                                            {t("signatureRequestView2.extentionPDFNotValid")}
                                                        </span>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            {/*View document*/}
                                            <Grid container lg={12} md={12} sm={12} es={12}>
                                                {!mobileResolution && showAWS ? (
                                                    <Grid item lg={12} md={12} sm={12} es={12}>
                                                        {pdfAws}
                                                    </Grid>
                                                ) : null
                                                }
                                                {props.selectedFile && (
                                                    <React.Fragment>
                                                        {!mobileResolution && !showAWS ? (
                                                            <Grid item lg={12} md={12} sm={12} es={12}>
                                                                {pdf}
                                                            </Grid>
                                                        ) : null}

                                                        {mobileResolution && (
                                                            <div className="pdf-btn-profile">
                                                                <DialogPdf blobUrl={blobUrl} />
                                                            </div>
                                                        )}
                                                    </React.Fragment>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </div>
                                </DialogPdfHLPure>
                            )
                        }
                        {
                            showDialogDelete ? (
                                <DialogYesNoHLPure
                                    cancel={closeShowDialogDelete}
                                    textBtnCancel={t("button.cancel")}
                                    saveBtn={t("button.delete")}
                                    titleDialog={'Eliminar contrato'}
                                    handleSubmit={handleDeleteContract}
                                >
                                    <h1>
                                        {'¿Estas seguro de eliminar el contrato?'}
                                    </h1>
                                </DialogYesNoHLPure>
                            ) : null
                        }
                        {
                            showCompletedRequesting || showLoadingRequesting || showErrorRequesting ?
                                <DialogSystemGLPure
                                    showLoadingRequesting={showLoadingRequesting}
                                    showCompletedRequesting={showCompletedRequesting}
                                    showErrorRequesting={showErrorRequesting}
                                    toggleLoadingRequesting={toggleLoadingRequesting}
                                    toggleCompletedRequesting={toggleCompletedRequesting}
                                    toggleErrorRequesting={toggleErrorRequesting}
                                    message={messageError}
                                />
                                : null
                        }
                    </Container>
                )
            }
        </div>
    )
}

export default ContractRepseView